import { useTranslation } from 'react-i18next'

import PlainButton from 'app/common/ui-next/plain-button'
import PlainIcon, { iconTypes, colorTypes } from 'app/common/ui-next/plain-icon'
import { DotsLoader } from 'app/common/components/Loader'

import styles from './AccountButtons.scss'


type Props = {
  onReplenishClick: () => void
  onTransferClick: () => void
  isRefillAvailable: boolean
  isTransferAvailable: boolean
  loading: boolean
}

const AccountButtons = ({
  onReplenishClick,
  onTransferClick,
  isRefillAvailable,
  isTransferAvailable,
  loading,
}: Props) => {
  const { t } = useTranslation('finances')

  if (loading) {
    return (
      <div className={styles.loadingContainer}>
        <DotsLoader simple className={styles.loading} />
        &nbsp;
      </div>
    )
  }

  return (
    <div className={styles.root}>
      {isRefillAvailable
        && <PlainButton className={styles.button} onClick={onReplenishClick}>
          <PlainIcon
            type={iconTypes.PLUS}
            colorType={colorTypes.COLOR_WHITE}
          />
          &nbsp;
          {t('refill_menu_item1', 'Пополнить счет')}
        </PlainButton>}

      {isTransferAvailable
        && <PlainButton className={styles.button} onClick={onTransferClick}>
          <PlainIcon
            type={iconTypes.EXCHANGE}
            colorType={colorTypes.COLOR_WHITE}
          />
          &nbsp;
          {t('refill_menu_item2', 'Перевести')}
        </PlainButton>}
    </div>
  )
}

export default AccountButtons
